export default __webpack_public_path__ + "static/jasminaz-4cf54b62bb8c87281aebdb315174348d.png";